import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "timeline-item active" }
const _hoisted_2 = { class: "item-badge" }
const _hoisted_3 = { class: "item-content" }
const _hoisted_4 = { class: "ekn-box text-left" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = ["href"]
const _hoisted_8 = ["href"]

import { useWizardStepsStore } from "../store/wizardStepsStore";


export default /*@__PURE__*/_defineComponent({
  __name: 'Result',
  setup(__props) {

const store = useWizardStepsStore();

const result = store.currentStep.wizardStepResultDto;

const resultPageButtonText = (document.getElementById("resultPageButtonText") as HTMLInputElement).value;
const applyOnlineButtonText = (document.getElementById("applyOnlineButtonText") as HTMLInputElement).value;
const applyOnlineButtonLink = (document.getElementById("applyOnlineButtonLink") as HTMLInputElement).value;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(store).previousSteps.length + 1), 1 /* TEXT */),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h2", null, _toDisplayString(_unref(store).currentStep.caption), 1 /* TEXT */),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h3", null, _toDisplayString(_unref(result).heading), 1 /* TEXT */),
        (_unref(result).description)
          ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_unref(result).description), 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        (_unref(result).disclaimer)
          ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_unref(result).disclaimer), 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        (!_unref(result).hideResultPageLink)
          ? (_openBlock(), _createElementBlock("a", {
              key: 2,
              href: _unref(result).resultPageLink,
              class: "btn btn-primary button"
            }, _toDisplayString(_unref(resultPageButtonText)), 9 /* TEXT, PROPS */, _hoisted_7))
          : _createCommentVNode("v-if", true),
        (_unref(result).showApplyOnlineButton)
          ? (_openBlock(), _createElementBlock("a", {
              key: 3,
              href: _unref(applyOnlineButtonLink),
              class: "btn btn-primary js-btn-apply button",
              target: "_blank"
            }, _toDisplayString(_unref(applyOnlineButtonText)), 9 /* TEXT, PROPS */, _hoisted_8))
          : _createCommentVNode("v-if", true)
      ])
    ])
  ]))
}
}

})